import { NotificationType } from '@/modules/notifications/types/notification-type';

import { NotificationTypeDTO } from '../types/notification-type-dto';

/**
 * Maps NotificationTypeDTO (API response) to NotificationType (domain model).
 * Since enum values are identical strings, this is a direct cast with fallback.
 */
export const mapNotificationTypeFromDTO = (dto: NotificationTypeDTO): NotificationType => {
  if (Object.values(NotificationType).includes(dto as unknown as NotificationType)) {
    return dto as unknown as NotificationType;
  }
  return NotificationType.DEFAULT;
};

/**
 * Maps NotificationType (domain model) to NotificationTypeDTO (API request).
 */
export const mapNotificationTypeToDTO = (type: NotificationType): NotificationTypeDTO => {
  if (Object.values(NotificationTypeDTO).includes(type as unknown as NotificationTypeDTO)) {
    return type as unknown as NotificationTypeDTO;
  }
  return NotificationTypeDTO.DEFAULT;
};
